export default function showWhatsOnFilter(centreStatus: string): boolean {
  let shouldDisplay = false
  if (centreStatus === 'Open') {
    shouldDisplay = true
  }
  return shouldDisplay
}
